<template>
  <div class="container d-flex  main-container">
    <div class="my-auto" style="margin:auto;">
      <!-- <h1><img src="./../assets/images/b-logo-3.png" alt="logo" class="img-fluid"></h1> -->
      <div class="row">
        <div class="col-md-12" v-if="show_msg && maintenance_msg != ''">
          <div class="msg-area main-area  w-100" style="white-space: pre-line">
            {{ maintenance_msg }}
          </div>
        </div>
        <div class="col-md-12">
          <div class="login-area main-area  w-100 ">
            <div class="login-dtl loginpage">
              <LogoComponent :header="'マイページ'"/>
              <div class="login-form">
                <form @submit.prevent="handleLogin">
                  <div
                    v-if="
                      server_errors ||
                        errors.has('username') ||
                        errors.has('password')
                    "
                    class="alert alert-danger d-inline-flex"
                    role="alert"
                  >
                    {{ server_errors }}
                    {{ errors.first("username") }}<br v-if="errors.has('username')" />
                    {{ errors.first("password") }}
                  </div>
                  <div class="custom-form-block">
                    <div class="form-group row">
                      <div class="col-md-12">
                        <label>メールアドレス</label>
                        <div class="input-group custom-group">
                          <input
                            type="text"
                            class="form-control"
                            name="username"
                            placeholder=""
                            v-model="username"
                            v-validate.disable="'required|email'"
                            data-vv-as="メールアドレス"
                          />
                        </div>
                      </div>
                      <div class="col-md-12 mb-2">
                        <label>パスワード</label>
                        <div class="input-group custom-group">
                          <input
                            :type="inputType"
                            name="password"
                            class="form-control"
                            placeholder=""
                            v-model="password"
                            v-validate.disable="'required'"
                            data-vv-as="パスワード"
                          />
                          <!-- <i class="front-icon fa fa-lock" aria-hidden="true"></i> -->
                          <button
                            class="btn-eye"
                            type="button"
                            v-on:click.prevent="showPassword"
                          >
                            <i :class="eyeIcon" aria-hidden="true"></i>
                          </button>
                        </div>
                      </div>
                      <div class="col-md-12 mb-2">
                        <router-link to="/forgot-password" class="forgot-link"
                          >パスワードをお忘れの場合
                        </router-link>
                      </div>
                    </div>
                    <div
                      class="btn-toolbar mb-1"
                      role="toolbar"
                      aria-label="Toolbar with button groups"
                    >
                      <button
                        type="submit"
                        class="btn btn-cstm btn-cstm-third btn-cstm-primary"
                        :disabled="processing || !isFormValid"
                      >
                        ログイン
                      </button>
                    </div>
                    <div class="login-terms">
                      <router-link
                        to="/terms"
                        class="forgot-link "
                        style="color: #787878;"
                      >
                        ユーザー利用規約
                      </router-link>
                    </div>
                  </div>
                  <!-- ends custom-form-block -->
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- ends main-area -->
  </div>
</template>

<script>
import Api from '@/config/api';
import swal from 'sweetalert';
import { generatePKCE, generateState } from '@/utils/pkce';
import LogoComponent from './LogoComponent.vue';

export default {
  name: 'LoginForm',
  components: { LogoComponent },
  data() {
    return {
      username: '',
      password: '',
      processing: false,
      server_errors: null,
      inputType: 'password',
      eyeIcon: 'fa fa-eye-slash',
      maintenance_msg: '',
      show_msg: false,
    };
  },
  computed: {
    isFormValid() {
      return this.username.trim() !== '' && this.password.trim() !== '';
    }
  },
  methods: {
    getResponseData(res) {
      return res && res.data && res.data.data ? res.data.data : (res && res.data) || null;
    },

    getLoginErrorResult(error) {
      const response = error.response;
      if (!response) {
        return { message: 'Something went wrong.' };
      }
      const status = response.status;
      const code = response.data && response.data.error;
      const description = response.data && response.data.error_description;
      const errorsArr = response.data && response.data.errors;

      if (status === 422 && Array.isArray(errorsArr)) {
        const text = errorsArr.map((e) => (typeof e === 'string' ? e : (e && e.message) || e)).join(' ');
        return { message: text };
      }
      if (status === 401 && code === 'authentication_failed') {
        return { message: 'IDまたはパスワードが間違っています。' };
      }
      if (status === 402 && code === 'email_not_confirmed') {
        return { showEmailDialog: true };
      }
      if (status === 400 && code === 'invalid_client') {
        return { message: description || 'Invalid client.' };
      }
      if (status === 503) {
        return { message: description || 'System under maintenance.' };
      }
      return { message: description || 'IDまたはパスワードが間違っています。' };
    },

    showEmailNotConfirmedDialog() {
      this.server_errors = null;
      swal({
        title: 'メールアドレスの認証をお願いします',
        text: 'もう一度認証用のメールを送信しますか？',
        icon: 'warning',
        buttons: { cancel: 'いいえ', ok: 'はい' },
        dangerMode: true,
      }).then((ok) => {
        if (ok) {
          this.axios({
            method: 'post',
            data: { email: this.username },
            url: Api.url(Api.endpoints.NewVerifyEmail),
            withCredentials: true,
          }).then(async () => {
            await swal({
              text: '認証用のメールを再送しました。ご確認ください。',
              icon: 'success',
              buttons: { ok: 'はい' },
            });
          });
        }
      });
    },

    async handleLogin() {
      this.server_errors = null;
      this.processing = true;
      try {
        const check = await this.$validator.validate();
        if (!check) return;

        const { codeVerifier, codeChallenge } = await generatePKCE();
        const state = generateState();
        const authorizeRes = await this.axios({
          method: 'post',
          url: Api.url(Api.endpoints.AUTHORIZE),
          withCredentials: true,
          data: {
            client_id: Api.credentials.CLIENT_ID,
            username: this.username,
            password: this.password,
            code_challenge: codeChallenge,
            code_challenge_method: 'S256',
            state,
          },
        });

        const resData = this.getResponseData(authorizeRes);
        if (resData && resData.twofa_required) {
          this.$router.push('/twofa-sent');
          return;
        }

        const authorizationCode = resData && resData.authorization_code;
        if (!authorizationCode) {
          this.server_errors = 'Something went wrong.';
          return;
        }

        const tokenRes = await this.axios({
          method: 'post',
          url: Api.url(Api.endpoints.TOKEN),
          withCredentials: true,
          data: {
            client_id: Api.credentials.CLIENT_ID,
            authorization_code: authorizationCode,
            code_verifier: codeVerifier,
          },
        });

        const tokenPayload = this.getResponseData(tokenRes) || tokenRes.data;
        this.$auth.setToken(tokenPayload || tokenRes.data);
        this.$router.push(this.$route.query.redirect || '/');
      } catch (error) {
        const result = this.getLoginErrorResult(error);
        if (result.showEmailDialog) {
          this.showEmailNotConfirmedDialog();
        } else {
          this.server_errors = result.message;
        }
      } finally {
        this.processing = false;
      }
    },

    showPassword() {
      if (this.inputType === 'password') {
        this.inputType = 'text';
        this.eyeIcon = 'fa fa-eye';
      } else {
        this.inputType = 'password';
        this.eyeIcon = 'fa fa-eye-slash';
      }
    },
    async checkMaintenaceMsg() {
      try {
        const response = await this.axios({
          method: 'get',
          url: Api.url(Api.endpoints.SITE_INFO),
        });

        if (response.data) {
          const resData = response.data;

          if (resData.data.show_msg == true) {
            this.show_msg = resData.data.show_msg;
            this.maintenance_msg = resData.data.maintenance_msg;
          }
        } else {
          this.show_msg = false;
          this.show_msg = '';
        }
      } catch (error) {
        this.show_msg = false;
        this.maintenance_msg = '';
      }
    },
  },

  async mounted() {
    this.checkMaintenaceMsg();
  },
};
</script>

<style scoped>
label {
  color: #000000;
}
.is-valid {
  background-image: none;
}
.is-invalid {
  background-image: none;
}
.msg-area {
  padding: 40px;
  position: relative;
  max-width: 580px;
  display: table;
  margin: 0 auto;
  margin-bottom: 20px;
  border-radius: 0px;
  /* border: 1px solid #cc0000; */
  color: #cc0000;
  margin-top: -2rem;
  box-shadow: none !important;
  background: #fff;
}


.form-control {
  border: 1px solid #ced4da !important;
  border-radius: 4px;
  margin-bottom: 10px;
  background: #f8f9fa !important;
  padding: 8px;
}


@media (max-width:991px) {
  .msg-area {
    padding: 30px;
  }
}

</style>
